












































  import { Component, Prop } from 'vue-property-decorator'
  import OneInputTooltip from './OneInputTooltip.vue'
  import useQuantityUtils from '~/composables/useQuantityUtils'

  @Component
  export default class OneInputWithControls extends OneInputTooltip {
    name: string = 'one-input-with-controls'

    @Prop({
      type: Boolean,
    })
    notValid?: boolean

    @Prop({
      type: Boolean,
      default: false
    })
    disabled?: boolean

    incrementValue(): void {
      const { normalizedStep, roundToStepPrecision } = useQuantityUtils(
        this.intervalValue,
        this.minValue,
      )
      const current = Number(this.quantityValue)
      const next = roundToStepPrecision(current + (normalizedStep as any).value)
      this.onInput(next)
    }

    decrementValue(): void {
      const { STEP_EPSILON, normalizedStep, roundToStepPrecision } = useQuantityUtils(
        this.intervalValue,
        this.minValue,
      )
      const current = Number(this.quantityValue)
      const next = roundToStepPrecision(current - (normalizedStep as any).value)
      if (next + (STEP_EPSILON as number) < Number(this.minValue)) {
        return
      }
      this.onInput(next)
    }
  }
